/*
 * Module for the Service Purhase Time Block edit partial view
*/

rs.module("content/participant/member/servicepurchase/timeblockedit",

    ["controls/data/grid", "controls/components/event-banner"],

    function (gridModule, eventBanner) {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, interestGridLrsApi) {

            var form = $.js(jsSelectors.form);

            form.js(jsSelectors.contributionAmount).keyup(_toggleRecalculateInterestButton);
            form.js(jsSelectors.toDate).change(_toggleRecalculateInterestButton);

            form.js(jsSelectors.hourlyRate).keyup(_toggleCalculateSPCTimeBlockDetailsButton);
            form.js(jsSelectors.toDate).change(_toggleCalculateSPCTimeBlockDetailsButton);
            form.js(jsSelectors.fromDate).change(_toggleCalculateSPCTimeBlockDetailsButton);

            form.js(jsSelectors.calculateSPCTimeBlockDetailsButton).click(function () {

                _clearErrors();

                // show loading spinner
                form.js(jsSelectors.spinner).show();

                gridModule.update(
                    backendUrls.loadSPCTimeBlockDetails,
                    {
                        timeBlockKey: form.js(jsSelectors.timeBlockKey).val(),
                        fromDate: form.js(jsSelectors.fromDate).val(),
                        toDate: form.js(jsSelectors.toDate).val(),
                        hours: form.js(jsSelectors.hours).val(),
                        hourlyRate: form.js(jsSelectors.hourlyRate).val(),
                    },
                    interestGridLrsApi.agGridApi,
                    function done(gridUpdate) {

                        form.js(jsSelectors.calculatedContributionAmount).val(gridUpdate.context.calculatedContributionAmt);
                        form.js(jsSelectors.contributionAmount).val(gridUpdate.context.calculatedContributionAmt);
                        form.js(jsSelectors.calculatedContributionAmountHiddenField).val(gridUpdate.context.calculatedContributionAmt);

                        form.js(jsSelectors.calculatedServiceCredit).val(gridUpdate.context.calculatedServiceAmt);
                        form.js(jsSelectors.serviceCredit).val(gridUpdate.context.calculatedServiceAmt);
                        form.js(jsSelectors.overrideVestingAmount, { required: false }).val(gridUpdate.context.calculatedServiceAmt);
                        form.js(jsSelectors.calculatedVestingAmount, { required: false }).val(gridUpdate.context.calculatedServiceAmt);
                        form.js(jsSelectors.calculatedServiceCreditHiddenField).val(gridUpdate.context.calculatedServiceAmt);
                        form.js(jsSelectors.calculatedVestingAmountHiddenField, { required: false }).val(gridUpdate.context.calculatedServiceAmt);

                        form.js(jsSelectors.calculatedSalaryAmount).val(gridUpdate.context.calculatedSalaryAmt);
                        form.js(jsSelectors.salaryAmount).val(gridUpdate.context.calculatedSalaryAmt);
                        form.js(jsSelectors.calculatedSalaryAmountHiddenField).val(gridUpdate.context.calculatedSalaryAmt);

                        form.js(jsSelectors.calculatedInterestAmount).val(gridUpdate.context.calculatedInterestAmt);
                        form.js(jsSelectors.interestAmount).val(gridUpdate.context.calculatedInterestAmt);
                        form.js(jsSelectors.calculatedInterestHiddenField).val(gridUpdate.context.calculatedInterestAmt);

                        // show interest schedule
                        form.js(jsSelectors.calcInterestSchedule).show();
                    }

                ).fail(function () {
                    form.js(jsSelectors.interestAmount).val(null);
                    form.js(jsSelectors.calculatedContributionAmount).val(null);
                    form.js(jsSelectors.calculatedServiceCredit).val(null);
                    form.js(jsSelectors.calculatedSalaryAmount).val(null);
                    form.js(jsSelectors.calculatedInterestAmount).val(null);
                    form.js(jsSelectors.overrideVestingAmount, { required: false }).val(null);
                    form.js(jsSelectors.calculatedVestingAmount, { required: false }).val(null);

                    // hide interest schedule
                    form.js(jsSelectors.calcInterestSchedule).hide();

                }).always(function () {

                    // hide loading spinner
                    form.js(jsSelectors.spinner).hide();
                });
            });

            form.js(jsSelectors.recalculateInterestButton).click(function () {

                _clearErrors();

                // show loading spinner
                form.js(jsSelectors.spinner).show();

                gridModule.update(
                    backendUrls.loadInterestSchedule,
                    {
                        balance: form.js(jsSelectors.contributionAmount).val(),
                        balanceDate: form.js(jsSelectors.toDate).val(),
                    },
                    interestGridLrsApi.agGridApi,
                    function done(gridUpdate) {

                        form.js(jsSelectors.interestAmount).val(gridUpdate.context.interestAmount);

                        // show interest schedule
                        form.js(jsSelectors.calcInterestSchedule).show();
                    }

                ).fail(function () {

                    form.js(jsSelectors.interestAmount).val(null);

                    // hide interest schedule
                    form.js(jsSelectors.calcInterestSchedule).hide();

                }).always(function () {

                    // hide loading spinner
                    form.js(jsSelectors.spinner).hide();
                });

                _resetRecalculateInterestButton();
            });

            //
            // Enable or disable the calculate interest button based on the hourlyRate, To Date, and From Date fields
            //
            function _toggleCalculateSPCTimeBlockDetailsButton() {
                var enabled = form.js(jsSelectors.hourlyRate).normalizedCurrencyVal() > 0 && form.js(jsSelectors.toDate).val() != "" && form.js(jsSelectors.fromDate).val() != "";
                form.js(jsSelectors.calculateSPCTimeBlockDetailsButton).setDisabled(!enabled);
            }

            //
            // Enable or disable the recalculate interest button based on the Contribution and To Date fields
            //
            function _toggleRecalculateInterestButton() {
                var enabled = form.js(jsSelectors.contributionAmount).normalizedCurrencyVal() > 0 && form.js(jsSelectors.toDate).val() != "";
                form.js(jsSelectors.recalculateInterestButton).setDisabled(!enabled);
            }

            //
            // Disable recalculate interest button, called after button is clicked
            //
            function _resetRecalculateInterestButton() {
                form.js(jsSelectors.recalculateInterestButton).setDisabled(true);
            }

            //
            // Clear event banner and field errors
            //
            function _clearErrors() {

                // clear event banner
                eventBanner.removeAllMessages();
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);